var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useToast } from 'shared/components';
import { noteSchemaInstanceMap } from 'constants/note-schemas';
import { useSignNote } from '.';
import { validateAndFocusInvalidFields } from 'shared/utils';
import { useState } from 'react';
import { useTrackedDisclosure, useTrackEvent } from 'shared/features/analytics';
import { EVENT_TYPE } from 'shared/utils/mixpanel';
import { flattenErrorsToPaths } from 'shared/utils';
import { ToastErrorBox } from 'shared/components/features/ToastErrorBox';
import { useSharedNoteEventData } from 'pages/Note/hooks';
export var useSignForm = function (_a) {
    var schema = _a.schema, noteForm = _a.noteForm, noteId = _a.noteId, saveDraft = _a.saveDraft;
    var toast = useToast();
    var trackEvent = useTrackEvent();
    var signConfirmDisclosure = useTrackedDisclosure('Sign Note', { spring_doc_id: 'compass011' });
    var signMutation = useSignNote({
        onError: function (error) {
            var _a, _b;
            var message = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            toast({
                status: 'error',
                duration: 15000,
                position: 'top',
                render: function (_a) {
                    var onClose = _a.onClose;
                    return (_jsx(ToastErrorBox, { onClose: onClose, title: "Failed to save note:", message: message }));
                },
            });
        },
    });
    var signConfirmed = function () {
        signMutation.mutate(__assign(__assign({}, noteSchemaInstanceMap[schema].prepareFormForSave(noteForm)), { id: noteId, noteSchema: schema }));
    };
    var _b = useState({}), focusEvents = _b[0], addFocusEvent = _b[1];
    var addFocusEventForPath = function (path, focusEvent) {
        addFocusEvent(function (oldFocusEvents) {
            var _a;
            return (__assign(__assign({}, oldFocusEvents), (_a = {}, _a[path] = focusEvent, _a)));
        });
    };
    var eventData = useSharedNoteEventData(noteId);
    var signNoteClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, paths;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validateAndFocusInvalidFields(noteForm, focusEvents)];
                case 1:
                    isValid = _a.sent();
                    if (!isValid) {
                        paths = flattenErrorsToPaths(noteForm.formState.errors);
                        paths.forEach(function (path) {
                            trackEvent(EVENT_TYPE.ERROR_MESSAGE_VIEWED, location.pathname, 'Note Validation Error', __assign({ spring_doc_id: 'compass008', section: path.split('.')[0], title: path.split('.')[1] }, eventData));
                        });
                    }
                    if (isValid) {
                        saveDraft();
                        signConfirmDisclosure.onOpen();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var signActionProps = {
        signMutation: signMutation,
        signNoteClick: signNoteClick,
    };
    var signFormProps = {
        signConfirmed: signConfirmed,
        signConfirmDisclosure: signConfirmDisclosure,
        addFocusEventForPath: addFocusEventForPath,
    };
    return {
        signActionProps: signActionProps,
        signFormProps: signFormProps,
    };
};
